// extracted by mini-css-extract-plugin
export var mobileMenu = "Header-module--mobile-menu--793a1";
export var mobileMenuToggle = "Header-module--mobile-menu-toggle--6cf9c";
export var mobileMenuToggleText = "Header-module--mobile-menu-toggle-text--d97bb";